export default {
  container: {
    textAlign: 'center',
  },
  button: {
    margin: 10,
  },
};



// WEBPACK FOOTER //
// ./src/components/Home/styles.js